require('../../../core/frontend/groupon_modules/groupon');

Groupon.Keymap = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'END': 35,
  'HOME': 36,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46
};

window.Groupon.AriaMenuNavigation = (function() {
  function AriaMenuNavigation() {}

  AriaMenuNavigation.prototype.initMenuNavigation = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    this.$menuTrigger = $menuTrigger;
    this.$menu = $menu;
    this.$menuLinks = $menuLinks;
    this.initAriaAttributes($menuTrigger, $menu, $menuLinks, menuTriggerParent);
    return this.bindMenu();
  };

  AriaMenuNavigation.prototype.initAriaAttributes = function($menuTrigger, $menu, $menuLinks, menuTriggerParent) {
    var $triggerWrapper, menuExists, menuID;
    if ($menu.length) {
      menuExists = true;
      if (!$menu[0].id) {
        $menu[0].id = _.uniqueId('sls-aria-');
      }
      menuID = $menu[0].id;
    }
    if (!$menuTrigger[0].id) {
      $menuTrigger[0].id = _.uniqueId('sls-aria-');
    }
    $menuTrigger.attr({
      'role': 'menuitem',
      'aria-haspopup': menuExists,
      'aria-owns': menuID,
      'tabindex': '0'
    });
    $triggerWrapper = this.ariaFindClosestParent($menuTrigger, menuTriggerParent);
    $triggerWrapper.attr({
      'role': 'menubar'
    });
    if (!menuExists) {
      return;
    }
    $menu.attr({
      'role': 'menu',
      'aria-hidden': 'true',
      'aria-labelledby': $menuTrigger[0].id
    });
    return $menuLinks.attr({
      'tabindex': '-1',
      'role': 'menuitem'
    });
  };

  AriaMenuNavigation.prototype.ariaFindClosestParent = function($source, selector) {
    var $parent;
    if (selector == null) {
      selector = '';
    }
    if (!selector) {
      if ($source.parent()[0].nodeName === 'LI') {
        selector = 'ul';
      } else {
        selector = 'nav';
      }
    }
    $parent = $source.closest(selector);
    return $parent = $parent.length ? $parent : $source.closest('div');
  };

  AriaMenuNavigation.prototype.bindMenu = function() {
    this.ariaBindMenuTrigger(this.$menuTrigger);
    return this.ariaBindMenuLinks();
  };

  AriaMenuNavigation.prototype.ariaBindMenuTrigger = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          _this.$menu.attr('aria-hidden', 'false').show();
          return _this.$menuLinks.eq(0).focus().attr('tabindex', 0);
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBindMenuLinks = function() {
    this.$menuLinks.off('keydown');
    return this.$menuLinks.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, ESCAPE, TAB, UP, keycode, linkIndex, ref;
        keycode = e.keyCode;
        ref = Groupon.Keymap, UP = ref.UP, DOWN = ref.DOWN, ESCAPE = ref.ESCAPE, TAB = ref.TAB;
        if (keycode === ESCAPE || keycode === TAB) {
          e.keyCode = ESCAPE;
          return _this.ariaCloseMenu(_this.$menuTrigger);
        } else {
          linkIndex = $.inArray(e.currentTarget, _this.$menuLinks);
          if (keycode === UP) {
            if (linkIndex === 0) {
              _this.ariaResetIndex(linkIndex);
              _this.ariaBrowseLinks(_this.$menuLinks.length - 1, 0);
            } else {
              _this.ariaBrowseLinks(linkIndex, -1);
            }
          }
          if (keycode === DOWN) {
            if (linkIndex === _this.$menuLinks.length - 1) {
              _this.ariaResetIndex(linkIndex);
              return _this.ariaBrowseLinks(0, 0);
            } else {
              return _this.ariaBrowseLinks(linkIndex, 1);
            }
          }
        }
      };
    })(this));
  };

  AriaMenuNavigation.prototype.ariaBrowseLinks = function(i, sibling) {
    this.ariaResetIndex(i);
    return this.$menuLinks.eq(i + sibling).focus().attr('tabindex', '0');
  };

  AriaMenuNavigation.prototype.ariaResetIndex = function(i) {
    return this.$menuLinks.eq(i).attr('tabindex', '-1');
  };

  AriaMenuNavigation.prototype.ariaCloseMenu = function($trigger) {
    if ($trigger == null) {
      $trigger = this.$menuTrigger;
    }
    this.$menu.attr('aria-hidden', 'true').hide();
    this.$menuLinks.attr('tabindex', '-1');
    return $trigger.focus();
  };

  return AriaMenuNavigation;

})();

//# sourceMappingURL=data:application/json;base64,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
